require('../../../core/frontend/groupon_modules/groupon');

Groupon.Keymap = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'END': 35,
  'HOME': 36,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46
};

window.Groupon.AriaMenuNavigation = (function() {
  function AriaMenuNavigation() {}

  AriaMenuNavigation.prototype.initMenuNavigation = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    this.$menuTrigger = $menuTrigger;
    this.$menu = $menu;
    this.$menuLinks = $menuLinks;
    this.initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent);
    return this.bindMenu();
  };

  AriaMenuNavigation.prototype.initAriaAttributes = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    var $triggerWrapper, menuExists, menuID;
    if ($menu.length) {
      menuExists = true;
      if (!$menu[0].id) {
        $menu[0].id = _.uniqueId('sls-aria-');
      }
      menuID = $menu[0].id;
    }
    if (!$menuTrigger[0].id) {
      $menuTrigger[0].id = _.uniqueId('sls-aria-');
    }
    $menuTrigger.attr({
      'role': 'menuitem',
      'aria-haspopup': menuExists,
      'aria-owns': menuID,
      'tabindex': '0'
    });
    $triggerWrapper = this.ariaFindClosestParent($menuTrigger, menuTriggerParent);
    $triggerWrapper.attr({
      'role': 'menubar'
    });
    if (!menuExists) {
      return;
    }
    $menu.attr({
      'role': 'menu',
      'aria-hidden': 'true',
      'aria-labelledby': $menuTrigger[0].id
    });
    return $menuLinks.attr({
      'tabindex': '-1',
      'role': 'menuitem'
    });
  };

  AriaMenuNavigation.prototype.ariaFindClosestParent = function($source, selector) {
    var $parent;
    if (selector == null) {
      selector = '';
    }
    if (!selector) {
      if ($source.parent()[0].nodeName === 'LI') {
        selector = 'ul';
      } else {
        selector = 'nav';
      }
    }
    $parent = $source.closest(selector);
    return $parent = $parent.length ? $parent : $source.closest('div');
  };

  AriaMenuNavigation.prototype.bindMenu = function() {
    this.ariaBindMenuTrigger(this.$menuTrigger);
    return this.ariaBindMenuLinks();
  };

  AriaMenuNavigation.prototype.ariaBindMenuTrigger = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          _this.$menu.attr('aria-hidden', 'false').show();
          return _this.$menuLinks.eq(0).focus().attr('tabindex', 0);
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBindMenuLinks = function() {
    this.$menuLinks.off('keydown');
    return this.$menuLinks.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, ESCAPE, TAB, UP, keycode, linkIndex, ref;
        keycode = e.keyCode;
        ref = Groupon.Keymap, UP = ref.UP, DOWN = ref.DOWN, ESCAPE = ref.ESCAPE, TAB = ref.TAB;
        if (keycode === ESCAPE || keycode === TAB) {
          e.keyCode = ESCAPE;
          return _this.ariaCloseMenu(_this.$menuTrigger);
        } else {
          linkIndex = $.inArray(e.currentTarget, _this.$menuLinks);
          if (keycode === UP) {
            if (linkIndex === 0) {
              _this.ariaResetIndex(linkIndex);
              _this.ariaBrowseLinks(_this.$menuLinks.length - 1, 0);
            } else {
              _this.ariaBrowseLinks(linkIndex, -1);
            }
          }
          if (keycode === DOWN) {
            if (linkIndex === _this.$menuLinks.length - 1) {
              _this.ariaResetIndex(linkIndex);
              return _this.ariaBrowseLinks(0, 0);
            } else {
              return _this.ariaBrowseLinks(linkIndex, 1);
            }
          }
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBrowseLinks = function(i, sibling) {
    this.ariaResetIndex(i);
    return this.$menuLinks.eq(i + sibling).focus().attr('tabindex', '0');
  };

  AriaMenuNavigation.prototype.ariaResetIndex = function(i) {
    return this.$menuLinks.eq(i).attr('tabindex', '-1');
  };

  AriaMenuNavigation.prototype.ariaCloseMenu = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    this.$menu.attr('aria-hidden', 'true').hide();
    this.$menuLinks.attr('tabindex', '-1');
    return $trigger.focus();
  };

  return AriaMenuNavigation;

})();

//# sourceMappingURL=data:application/json;base64,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
